require('../../../core/frontend/groupon_modules/groupon');

Groupon.Keymap = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'END': 35,
  'HOME': 36,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46
};

window.Groupon.AriaMenuNavigation = (function() {
  function AriaMenuNavigation() {}

  AriaMenuNavigation.prototype.initMenuNavigation = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    this.$menuTrigger = $menuTrigger;
    this.$menu = $menu;
    this.$menuLinks = $menuLinks;
    this.initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent);
    return this.bindMenu();
  };

  AriaMenuNavigation.prototype.initAriaAttributes = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    var $triggerWrapper, menuExists, menuID;
    if ($menu.length) {
      menuExists = true;
      if (!$menu[0].id) {
        $menu[0].id = _.uniqueId('sls-aria-');
      }
      menuID = $menu[0].id;
    }
    if (!$menuTrigger[0].id) {
      $menuTrigger[0].id = _.uniqueId('sls-aria-');
    }
    $menuTrigger.attr({
      'role': 'menuitem',
      'aria-haspopup': menuExists,
      'aria-owns': menuID,
      'tabindex': '0'
    });
    $triggerWrapper = this.ariaFindClosestParent($menuTrigger, menuTriggerParent);
    $triggerWrapper.attr({
      'role': 'menubar'
    });
    if (!menuExists) {
      return;
    }
    $menu.attr({
      'role': 'menu',
      'aria-hidden': 'true',
      'aria-labelledby': $menuTrigger[0].id
    });
    return $menuLinks.attr({
      'tabindex': '-1',
      'role': 'menuitem'
    });
  };

  AriaMenuNavigation.prototype.ariaFindClosestParent = function($source, selector) {
    var $parent;
    if (selector == null) {
      selector = '';
    }
    if (!selector) {
      if ($source.parent()[0].nodeName === 'LI') {
        selector = 'ul';
      } else {
        selector = 'nav';
      }
    }
    $parent = $source.closest(selector);
    return $parent = $parent.length ? $parent : $source.closest('div');
  };

  AriaMenuNavigation.prototype.bindMenu = function() {
    this.ariaBindMenuTrigger(this.$menuTrigger);
    return this.ariaBindMenuLinks();
  };

  AriaMenuNavigation.prototype.ariaBindMenuTrigger = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          _this.$menu.attr('aria-hidden', 'false').show();
          return _this.$menuLinks.eq(0).focus().attr('tabindex', 0);
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBindMenuLinks = function() {
    this.$menuLinks.off('keydown');
    return this.$menuLinks.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, ESCAPE, TAB, UP, keycode, linkIndex, ref;
        keycode = e.keyCode;
        ref = Groupon.Keymap, UP = ref.UP, DOWN = ref.DOWN, ESCAPE = ref.ESCAPE, TAB = ref.TAB;
        if (keycode === ESCAPE || keycode === TAB) {
          e.keyCode = ESCAPE;
          return _this.ariaCloseMenu(_this.$menuTrigger);
        } else {
          linkIndex = $.inArray(e.currentTarget, _this.$menuLinks);
          if (keycode === UP) {
            if (linkIndex === 0) {
              _this.ariaResetIndex(linkIndex);
              _this.ariaBrowseLinks(_this.$menuLinks.length - 1, 0);
            } else {
              _this.ariaBrowseLinks(linkIndex, -1);
            }
          }
          if (keycode === DOWN) {
            if (linkIndex === _this.$menuLinks.length - 1) {
              _this.ariaResetIndex(linkIndex);
              return _this.ariaBrowseLinks(0, 0);
            } else {
              return _this.ariaBrowseLinks(linkIndex, 1);
            }
          }
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBrowseLinks = function(i, sibling) {
    this.ariaResetIndex(i);
    return this.$menuLinks.eq(i + sibling).focus().attr('tabindex', '0');
  };

  AriaMenuNavigation.prototype.ariaResetIndex = function(i) {
    return this.$menuLinks.eq(i).attr('tabindex', '-1');
  };

  AriaMenuNavigation.prototype.ariaCloseMenu = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    this.$menu.attr('aria-hidden', 'true').hide();
    this.$menuLinks.attr('tabindex', '-1');
    return $trigger.focus();
  };

  return AriaMenuNavigation;

})();

//# sourceMappingURL=data:application/json;base64,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
